// Vortex Theme JavaScript
document.addEventListener('DOMContentLoaded', () => {
  console.log('Vortex Theme Loaded');
  
  // Basic cart notification logic or other interactions can be added here
});
